<template>
    <div class="search-te-co-box max-width-box">
        <div class="te-search-box">
            <div class="te-search">
                <img :src="require('@/assets/icon/search.png')" />
                <el-input v-model="searchForm.queryStr" placeholder="What do you want to learn？" @keyup.enter.native="dataChange"></el-input>
                <el-button @click.native="dataChange">search</el-button>
            </div>
        </div>
        
        <div class="te-count-sort">
            <div class="te-count">{{resultCount}}</div>
            <div class="te-sort">
                <el-button class="sort-default" :class="{'sort-selected':sortType==='Default'}" @click="changeSortMode('Default')">Default</el-button>
                <el-button class="sort-default" :class="{'sort-selected':sortType==='Evaluate'}" @click="changeSortMode('Evaluate')">
                    Evaluate
                    <i :class="{'el-icon-d-caret':counter[0]===0,
                                    'el-icon-caret-bottom':counter[0]===1,
                                    'el-icon-caret-top':counter[0]===2}">
                    </i>
                </el-button>
                <el-button class="sort-default" :class="{'sort-selected':sortType==='Price'}" @click="changeSortMode('Price')">
                    Price
                    <i :class="{'el-icon-d-caret':counter[1]===0,
                                    'el-icon-caret-bottom':counter[1]===1,
                                    'el-icon-caret-top':counter[1]===2}">
                    </i>
                </el-button>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name:'search-top',
    props:['resultCount'],
    data(){
        return{
            
            counter:[0,0],
            sortType: 'Default', //排序方式default：默认，asc从小到大 desc从大到小
            searchForm:{
                queryStr:'',
                sortcol:'',
                sorttype:''

            },
            sortModeParams:{
                0:'',
                1:'DESC',
                2:'ASC'
            },
            sortTypeParams:{
                Evaluate:'avgscore',
                Price:'price',
                Default:'',
            },
        }
    },
    methods:{
        
        //排序方式
        changeSortMode(mode) {

            if(this.sortType!==mode){
                this.sortType = mode;
                this.counter[0] = 0;
                this.counter[1] = 0;
            }else{
                if(mode==='Evaluate'){
                    this.$set(this.counter,0,(this.counter[0]+1)%3)
                }
                if(mode==='Price'){
                    this.$set(this.counter,1,(this.counter[1]+1)%3)
                }
            }
            this.dataChange();
        },
        //查询数据变化
        dataChange(){
            let params = {...this.searchForm}
            
            params.sortcol = this.sortTypeParams[this.sortType];
            if(this.sortType ==='Evaluate'){
                params.sorttype = this.sortModeParams[this.counter[0]]
            }
            if(this.sortType ==='Price'){
                params.sorttype = this.sortModeParams[this.counter[1]]
            }
            // console.log(params);
            this.$emit('searchChange',params);
        }
    }
}
</script>

<style lang="scss" scoped>
@import '~@/utils/vw.scss';
.search-te-co-box{
    margin: 0 auto;
    overflow:auto;
    .te-count-sort{
        margin-top: vw(40);
        display: flex;
        justify-content: space-between;
        align-items: center;
        .te-count {
            font-size: 24px;
            font-weight: 600;
            color: #201002;
            line-height: 24px;
        }
        .te-sort{
            .sort-default {
                border: none;
                padding: 6px 8px;
                margin-right: 16px;
                height: 32px;
                border-radius: 8px;
                color: #000;
                line-height: 20px;
                font-size: 14px;
                background: rgba(0, 0, 0, 0);
            }
            .sort-selected {
                color: #fff;
                background: #f48c06;
            }
        }
    }
    
    .te-search-box {
        margin-top: 93px;
    }
    .te-search {
        padding: 8px;
        display: flex;
        flex-direction: row;
        align-items: center;
        box-sizing: border-box;
        width: 100%;
        height: vw(64);
        background: #ffffff;
        box-shadow: 0px 4px 32px 0px rgba(0, 0, 0, 0.04);
        border-radius: 8px;
        img {
            margin-left: 8px;
            margin-right: 15px;
        }
        .el-button {
            background: #f48c06;
            height: vw(48);
            border-radius: 8px;
            border: none;
            color: #ffffff;
            font-weight: 600;
            line-height: vw(28);
            font-size: vw(20);
            display: flex;
            align-items: center;
        }
        /deep/ .el-input__inner {
            height: 100%;
            border: none;
            font-size: vw(20);
            color: #464646;
            line-height: vw(38);
        }
    }
}
</style>